import { useEffect } from 'react';

export default function useOutsideClick(ref, cb) {
  useEffect(() => {
    function handleClickOutside(event) {
      if (ref.current && !ref.current.contains(event.target)) {
        if (typeof cb === 'function') {
          cb();
        } else {
          console.warn('Callback is not a function in useOutsideClick');
        }
      }
    }

    // Bind the event listener
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      // Unbind the event listener on clean up
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [ref, cb]);
}



// WEBPACK FOOTER //
// ./app/javascript/client/hooks/useOutsideClick.js